<template>
    <div class="branded-workwear-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
      <div class="loading-spinner-outer" v-if="logging_into_brandhub">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Logging you in to Brandhub, please wait to be redirected
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Branded Workwear &amp; Merchandise in partnership with BrandHub360
                </div>
                <div class="logo">
                    <img src="/images/brandhub-360-header-logo.png">
                </div>
            </div>
            <div class="box-1">
                <h1>Discounted Workwear &amp; Merchandise with YOUR logo</h1>
                <p>
                  High quality workwear and merchandise competitively priced.
                </p>
                <div>
                    <a href="/brandhub-sso" class="btn-primary _lg" @click="partnerLinkClicked()">
                        <strong>Login to Brandhub360</strong>
                    </a>
                </div>
            </div>
            <div class="overlapping-image">
                <!--<img src="/images/marketing-branded-workwear-header.png">-->
                <youtube-embed videoId="OXRl33a8sHU"></youtube-embed>
            </div>
            <div class="box-2">
                <p>
                  Branded workwear and merchandise helps support your brand identity and provides a professional, uniformed approach.
                  Branded garments may seem like a work uniform but they represent so much more.
                  They represent your company’s objectives, present a professional polished image and are the perfect complement to your overall brand presentation.
                </p>
                <div v-if="!logged_in_user.isStaff">
                    <a class="btn-primary-outline _lg" @click.prevent="enquiry_box_open = true">
                        Request Login
                    </a>
                </div>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Branded Workwear Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I would like more information on signing up for a Brandhub360 account to purchase branded workwear and merchandise',
          sending: false,
          logging_into_brandhub: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 10,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Brandhub360 branded workwear enquiry',
                'value': 'Brandhub360 branded workwear enquiry',
              });

                this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
      partnerLinkClicked() {
          this.logging_into_brandhub = true;
        axios.post('/activity-logs/createActivityLogFromRequest', {
          'activity_log_category_id': 3,
          'description': `Partner Link Clicked - Brandhub360 Branded Workwear`,
        });
        gtag('event', 'partner_link_clicked', {
          'event_category': 'link',
          'event_label': 'Brandhub360 branded workwear partner link clicked',
          'value': 'Brandhub360 branded workwear partner link clicked',
        });
      },
    },
};
</script>
